import { render, staticRenderFns } from "./sideLayout.vue?vue&type=template&id=b2daf1be&"
import script from "./sideLayout.vue?vue&type=script&lang=js&"
export * from "./sideLayout.vue?vue&type=script&lang=js&"
import style0 from "./sideLayout.vue?vue&type=style&index=0&id=b2daf1be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports